import type { Node } from "interfaces/schemas";
import { NodeKinds } from "interfaces/enums";

export const isProduct = (node: Node): boolean =>
  node?.kind === NodeKinds.PRODUCT;

export const isFolder = (node: Node): boolean =>
  node?.kind === NodeKinds.FOLDER;

export const isRoot = (node: Node): boolean => node?.kind === NodeKinds.ROOT;

export const isWizardFolder = (node: Node): boolean =>
  node?.kind === NodeKinds.WIZARD_FOLDER;

export const isWizardRootFolder = (node: Node): boolean =>
  node?.kind === NodeKinds.WIZARD_ROOT_FOLDER;

export const isWizardProduct = (node: Node): boolean =>
  node?.kind === NodeKinds.WIZARD_PRODUCT;

export const isWizardCommissioningCost = (node: Node): boolean =>
  node?.kind === NodeKinds.WIZARD_COMMISIONING_COST;

export const isWizardProductAccessory = (node: Node): boolean =>
  node?.kind === NodeKinds.WIZARD_PRODUCT_ACCESSORY;

export const isWizard = (node: Node): boolean =>
  isWizardFolder(node) ||
  isWizardRootFolder(node) ||
  isWizardProduct(node) ||
  isWizardCommissioningCost(node) ||
  isWizardProductAccessory(node);

export const isTroxNetcomFolder = (node: Node): boolean =>
  node?.kind === NodeKinds.TROX_NETCOM_FOLDER;

export const isTroxNetcomProduct = (node: Node): boolean =>
  node?.kind === NodeKinds.TROX_NETCOM_PRODUCT;

export const isTroxNetcomNote = (node: Node): boolean =>
  node?.kind === NodeKinds.TROX_NETCOM_NOTE;

export const isTroxNetcomFolderRoot = (node: Node): boolean =>
  node?.kind === NodeKinds.TROX_NETCOM_FOLDER_ROOT;

export const isTroxNetcomGenericProduct = (node: Node): boolean =>
  node?.kind === NodeKinds.TROX_NETCOM_GENERIC_PRODUCT;

export const isTroxNetcom = (node: Node): boolean =>
  isTroxNetcomFolder(node) ||
  isTroxNetcomProduct(node) ||
  isTroxNetcomFolderRoot(node) ||
  isTroxNetcomGenericProduct(node) ||
  isTroxNetcomNote(node);

export const isCustomProduct = (node: Node): boolean =>
  node?.kind === NodeKinds.CUSTOM_PRODUCT;

export const isProductAccessory = (node: Node): boolean =>
  node?.kind === NodeKinds.PRODUCT_ACCESSORY ||
  node?.kind === NodeKinds.WIZARD_PRODUCT_ACCESSORY;

export const isAnyProduct = (node: Node): boolean =>
  isProduct(node) ||
  isWizardProduct(node) ||
  isWizardCommissioningCost(node) ||
  isTroxNetcomProduct(node) ||
  isCustomProduct(node) ||
  isTroxNetcomNote(node) ||
  isProductAccessory(node);

export const isAnyAccessory = (node: Node): boolean =>
  isProductAccessory(node) || isWizardProductAccessory(node);

export const isAnyFolder = (node: Node): boolean =>
  isFolder(node) ||
  isRoot(node) ||
  isWizardFolder(node) ||
  isWizardRootFolder(node) ||
  isTroxNetcomFolder(node) ||
  isTroxNetcomFolderRoot(node);

// export const isLinkedWizardFolder = (node: Node) => {
//   return node.kind === NodeKinds.LINKED_WIZARD_FOLDER;
// }

// export const isLinkedWizardProduct = (node: Node) => {
//   return node.kind === NodeKinds.LINKED_WIZARD_PRODUCT;
// }

// export const isXcube = (node: Node) => {
//   return node.kind === NodeKinds.XCUBE;
// }

export const isLeafNode = (node: Node): boolean =>
  !("nodes" in node) || !(Array.isArray(node.nodes) && node.nodes.length > 0);
